// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7197":"aeb5c345","8280":"212d72fb"}[chunkId] + ".chunk.css";
};